module.exports = __webpack_public_path__ + "img/cloggedcatchbasin.ba2a5b4f.svg";